<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> usuario <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content>

  <ng-template *ngIf="action === 'Delete'">
    Seguro quiere eliminar al tipo usuario <b>{{LOCAL_DATA.nombre}}</b>?
  </ng-template>

  <mat-form-field *ngIf="action != 'Delete'" class="select-medio">
    <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre">
  </mat-form-field>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
